import {Component, HostBinding, inject, input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  imports: []
})
export class ModalContainerComponent {
  activeModal = inject(NgbActiveModal);

  readonly title = input<string>();
  readonly largeModal = input(false);

  @HostBinding('class.large-modal') get largeModalClass() {
    return this.largeModal();
  }

}
